import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { GenericIconScreen } from '@/components/shared/GenericIconScreen/GenericIconScreen';
import { Button } from '@/components/ui/Button/Button';
import { useIsOnline } from '@/hooks/pwa/useIsOnline';
import { WifiOff } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

export const OfflineBoundary = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('utils', {
    keyPrefix: 'offlinePage',
  });

  const isOnline = useIsOnline();

  if (isOnline) return <>{children}</>;

  return (
    <GenericLayout isAnchor>
      <GenericIconScreen
        Icon={WifiOff}
        title={t('title')}
        description={t('description')}
        role='alert'
        aria-live='assertive'
        leftActionElement={
          <Button className='w-full' onClick={() => globalThis.location.reload()}>
            {t('button.label')}
          </Button>
        }
      />
    </GenericLayout>
  );
};
